export default __webpack_public_path__ + "static/media/shin.png.webp";